import { Box, Button, Flex, FormControl, HStack, Text, useDisclosure } from '@chakra-ui/react'
import { useContext } from 'react'

import { useGetAvailableBusinessmen } from '@/hooks/useInsuranceParams'
import { useParams } from 'react-router'
import { FormLabel } from '../components/FormLabel'
import {
  FormSection,
  FormSectionBody,
  FormSectionHeader,
  FormSectionTitle,
} from '../components/FormSection'
import { Loading } from '../components/Loading'
import { MainContent } from '../components/MainContent'
import { meetingRecordContext } from '../pages/carkulka/wizard/5'

export const MeetingRecordCarExtraOverview = () => {
  const { insuranceParamsId } = useParams()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { meetingRecord, isLoading } = useContext(meetingRecordContext)
  const { data: dataBusinessmen } = useGetAvailableBusinessmen(insuranceParamsId!)

  const isBusinessmanOrManager = !!meetingRecord && !!dataBusinessmen

  return (
    <MainContent>
      <FormSection>
        <FormSectionHeader>
          <FormSectionTitle>Záznam z jednání</FormSectionTitle>
        </FormSectionHeader>

        <FormSectionBody sx={{ gap: 8 }}>
          {isOpen && (
            <>
              {isLoading && <Loading large={true} />}
              {!isLoading && <Box sx={{ display: 'grid', gap: 4 }}>
                <FormControl variant="fullWidth">
                  <FormLabel>
                    Případné nesrovnalosti mezi požadavky Zákazníka a sjednávaným pojištěním nebo jeho
                    podstatnou změnou
                  </FormLabel>

                  {<Text>{meetingRecord?.irregularities ? meetingRecord?.irregularities : 'Žádné nesrovnalosti.'}</Text>}
                </FormControl>

                <FormControl variant="fullWidth">
                  <FormLabel>
                    Popis dopadů sjednání/změny/ukončení pojištění, včetně souvisejících rizik - V případě doporučení sjednání nové pojistné smlouvy nebo její podstatné změny je třeba vysvětlit dopady takového jednání vč. souvisejících rizik u každého sjednaného pojistného produktu.
                  </FormLabel>

                  {<Text>{meetingRecord?.consequences ? meetingRecord?.consequences : 'Žádný popis.'}</Text>}
                </FormControl>

                <FormControl>
                  <FormLabel tooltip="Zákazník odmítá sdělit další požadavky?">
                    Zákazník odmítá sdělit další požadavky?
                  </FormLabel>

                  <Text>{meetingRecord?.refusesMoreDetails ? 'Ano' : 'Ne'}</Text>
                </FormControl>

                <FormControl variant="fullWidth">
                  <FormLabel>
                    Další požadavky, potřeby a cíle zákazníka
                  </FormLabel>
                  {<Text>{meetingRecord?.additionalClientRequirements ? meetingRecord?.additionalClientRequirements : 'Žádné další požadavky.'}</Text>}
                </FormControl>

                <FormControl>
                  <FormLabel tooltip="Má zákazník vedle této pojistné smlouvy uzavřenou další se stejným krytím?">
                    Má zákazník vedle této pojistné smlouvy uzavřenou další se stejným krytím?
                  </FormLabel>

                  <Text>{meetingRecord?.hasMoreContracts ? 'Ano' : 'Ne'}</Text>
                </FormControl>

                <FormControl>
                  <FormLabel>Místo sjednání</FormLabel>

                  <Text>{meetingRecord?.placeOfContract}</Text>
                </FormControl>

                {isBusinessmanOrManager &&
                  <>
                    <FormLabel >Sjednání za jiného uživatele</FormLabel>

                    <Box sx={{ display: 'grid', gap: 4 }}>
                      <HStack>
                        <FormLabel >Ziskatel</FormLabel>
                        <Text>{meetingRecord.businessmanFullname ?? 'Neuveden'}</Text>
                      </HStack>

                      <HStack>
                        <FormLabel >Správce</FormLabel>
                        <Text>{meetingRecord.managerFullname ?? 'Neuveden'}</Text>
                      </HStack>
                    </Box>
                  </>
                }
              </Box>}
            </>
          )}

          <Flex sx={{ w: '100%', placeContent: 'end' }}>
            <Button variant="outline" onClick={isOpen ? onClose : onOpen}>
              {isOpen ? 'Skrýt záznam z jednání' : 'Zobrazit záznam z jednání'}
            </Button>
          </Flex>
        </FormSectionBody>
      </FormSection>
    </MainContent>
  )
}
